module.exports = __webpack_public_path__ + "media/images/icon/movie-6b9f998153a5c431f6be37552cb3c835.png";